import { useEffect, useRef } from "react";
import { CContainer, CHeader, CHeaderNav, CHeaderToggler } from "@coreui/react";
import AppHeaderDropdown from "./AppHeaderDropdown";
import { useNav } from "../../context/NavContext";
import { stringifyName } from "../../utils/helpers";
import { MenuOpenRounded } from "@mui/icons-material";
import {
  NotificationsOutline,
  SettingsOutline,
} from "@raresail/react-ionicons";
import { IconButton } from "@mui/material";
import { APP_NAME } from "../../utils/constants";
import { Link } from "react-router-dom";
import { URL_NOTIFICATIONS, URL_SETTINGS } from "../../utils/urls";
import ReportsDropdown from "./ReportsDropdown";
import { LogoHorizontalSVG } from "../../assets/svg/SvgIcons";
import { IsAdmin, IsManager, IsSuperUser } from "../../utils/permissions";

const AppHeader = ({ profile }) => {
  const isSupper = IsSuperUser();
  const isAdmin = IsAdmin();
  const isManager = IsManager();
  const headerRef = useRef<HTMLDivElement>();
  const { sidebarShow, setSidebarShow } = useNav();

  useEffect(() => {
    if (profile) {
      window.document.title = `${APP_NAME}: ${stringifyName(profile)}`;
    }
  }, [profile]);

  useEffect(() => {
    document.addEventListener("scroll", () => {
      headerRef.current &&
        headerRef.current?.classList.toggle(
          "shadow-sm",
          document.documentElement.scrollTop > 0,
        );
    });
  }, []);

  return (
    <CHeader
      style={{ zIndex: 100 }}
      position="sticky"
      className="mb-4 p-0"
      ref={headerRef as any}
    >
      <CContainer className="border-bottom px-4" fluid>
        <CHeaderToggler
          onClick={() => setSidebarShow(!sidebarShow)}
          style={{ marginInlineStart: "-14px" }}
        >
          <MenuOpenRounded />
        </CHeaderToggler>

        <div
          style={{ lineHeight: 1.2, marginLeft: 10 }}
          className="flexNullCenter gap10"
        >
          <div>
            <img src={LogoHorizontalSVG} height={25} width={100} />
          </div>
          <CHeaderNav>
            <ReportsDropdown />
          </CHeaderNav>
        </div>

        <CHeaderNav className="ms-auto gap10" />
        <div className="flexNullCenter gap10">
          {(isManager || isAdmin || isSupper) && (
            <Link to={`register${URL_NOTIFICATIONS}`}>
              <IconButton size="small" sx={{ bgcolor: "#eee" }}>
                <NotificationsOutline />
              </IconButton>
            </Link>
          )}
          <Link to={URL_SETTINGS}>
            <IconButton size="small" sx={{ bgcolor: "#eee" }}>
              <SettingsOutline />
            </IconButton>
          </Link>

          <CHeaderNav>
            <AppHeaderDropdown />
          </CHeaderNav>
        </div>
      </CContainer>
    </CHeader>
  );
};

export default AppHeader;
